import { Grid, Paper, Text, Group } from '@mantine/core';
import { MdEmail, MdSend, MdInbox } from 'react-icons/md';

interface StatsCardsProps {
    totalSent: number;
    totalReceived: number;
    totalMessages: number;
}

export const StatsCards = ({ totalSent, totalReceived, totalMessages }: StatsCardsProps) => {
    return (
        <Grid>
            <Grid.Col span={4}>
                <Paper p="md" withBorder>
                    <Group>
                        <MdEmail size={32} color="#228be6" />
                        <div>
                            <Text size="xl" fw={700}>{totalMessages}</Text>
                            <Text size="sm" c="dimmed">Total Messages</Text>
                        </div>
                    </Group>
                </Paper>
            </Grid.Col>
            <Grid.Col span={4}>
                <Paper p="md" withBorder>
                    <Group>
                        <MdSend size={32} color="#40c057" />
                        <div>
                            <Text size="xl" fw={700}>{totalSent}</Text>
                            <Text size="sm" c="dimmed">Sent</Text>
                        </div>
                    </Group>
                </Paper>
            </Grid.Col>
            <Grid.Col span={4}>
                <Paper p="md" withBorder>
                    <Group>
                        <MdInbox size={32} color="#fd7e14" />
                        <div>
                            <Text size="xl" fw={700}>{totalReceived}</Text>
                            <Text size="sm" c="dimmed">Received</Text>
                        </div>
                    </Group>
                </Paper>
            </Grid.Col>
        </Grid>
    );
};
